import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productQuantityOrderedStyles } from "@insite/content-library/Components/ProductQuantityOrdered";
import { css } from "styled-components";

productQuantityOrderedStyles.cssOverrides = mergeToNew(productQuantityOrderedStyles.cssOverrides, {
    formInputWrapper: css`
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
            /* ISC-11023 deal with this. */
            /* stylelint-disable-next-line */
            -webkit-appearance: none;
            margin: 0;
        }
    `,
    inputSelect: css`
        /* ISC-11023 deal with this. */
        /* stylelint-disable-next-line */
        -moz-appearance: textfield;
        border-radius: 6px;
    `,
});

productQuantityOrderedStyles.labelProps = mergeToNew(productQuantityOrderedStyles.labelProps, {
    css: css`
        display: none;
    `,
});
